import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-24e509a2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "global"
};
const _hoisted_2 = {
  id: "copy"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link"
}, [/*#__PURE__*/_createElementVNode("span", null, "Please contact us in the following ways")], -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address-title"
}, "Linkedin", -1));

const _hoisted_5 = {
  class: "address-content"
};
const _hoisted_6 = {
  class: "address-content-part"
};
const _hoisted_7 = ["href"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy"
}, null, -1));

const _hoisted_9 = [_hoisted_8];

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address-title"
}, "Eamil", -1));

const _hoisted_11 = {
  class: "address-content"
};
const _hoisted_12 = {
  id: "shareUrl2"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy"
}, null, -1));

const _hoisted_14 = [_hoisted_13];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Apply for this Job", -1));

const _hoisted_16 = [_hoisted_15];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    top: $data.scrollTop + 100 + 'px',
    id: "modal",
    modelValue: $data.showModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.showModal = $event),
    title: "Apply for this Job",
    width: "480px",
    "open-auto-focus": "",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("a", {
      target: "_blank",
      href: $data.text,
      id: "shareUrl1"
    }, _toDisplayString($data.text), 9, _hoisted_7)]), _createElementVNode("div", null, [_createElementVNode("button", {
      ref: "copyText",
      "data-clipboard-target": "#shareUrl1",
      class: "copy-btn iconfont icon-fuzhi",
      onClick: _cache[0] || (_cache[0] = $event => $options.copy($event))
    }, _hoisted_9, 512)])]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("h5", _hoisted_12, _toDisplayString($data.text1), 1), _createElementVNode("button", {
      ref: "copyText",
      "data-clipboard-target": "#shareUrl2",
      class: "copy-btn iconfont icon-fuzhi",
      onClick: _cache[1] || (_cache[1] = $event => $options.copy($event))
    }, _hoisted_14, 512)])])]),
    _: 1
  }, 8, ["top", "modelValue"]), _createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = $event => $data.showModal = true),
    class: "btn"
  }, _hoisted_16)]);
}